/**
 * Created by bob.gear on 16/03/2015.
 */

var EICDataStream3ContractDisplay = angular.module("EICDataStream3.contractDisplay", ["EICDataStream3.resources", "EICDataStream3.logging"])
  .config(function () {
  });


EICDataStream3ContractDisplay.controller('ContractDisplayController', ['$scope',
  function ($scope) {

    $scope.componentName = "ContractDisplayController";

    $scope.$on("EXPAND_CONTRACTS", function(){
      $scope.isExpanded = true;
    });

    $scope.$on("COLLAPSE_CONTRACTS", function () {
      $scope.isExpanded = false;
    });

    $scope.toggleContractExpanded = function(){
      $scope.isExpanded = !$scope.isExpanded;
    };

    $scope.isExpanded = false;
  }]);



EICDataStream3ContractDisplay.controller('ContractStageController', ['$scope',
  function ($scope) {

    $scope.componentName = "ContractStageController";


    $scope.collapseAll = function () {
      $scope.$broadcast("COLLAPSE_CONTRACTS");
      $scope.allExpanded = false;
      $scope.allCollapsed = true;

      $scope.collapsedStyle = "btn btn-xs btn-default";
      $scope.expandedStyle = "btn btn-xs btn-default active";
    };
    $scope.expandAll = function () {
      $scope.$broadcast("EXPAND_CONTRACTS");
      $scope.allExpanded = true;
      $scope.allCollapsed = false;

      $scope.collapsedStyle = "btn btn-xs btn-default active";
      $scope.expandedStyle = "btn btn-xs btn-default";
    };

    $scope.collapsedStyle = "btn btn-xs btn-default";
    $scope.expandedStyle = "btn btn-xs btn-default active";
  }]);



EICDataStream3ContractDisplay.controller('ContractController', ['$scope', '$state', '$stateParams', '$location', '$document', '$window', 'searchService', 'contractDataService', 'feedbackService', 'FEATURE_SWITCHES',
  function ($scope, $state, $stateParams, $location, $document, $window, searchService, contractDataService, feedbackService, FEATURE_SWITCHES) {

    $scope.componentName = "ContractController";
    $scope.MEMBER_FEEDBACK  = FEATURE_SWITCHES.MEMBER_FEEDBACK;

    $scope.searchService = searchService;
    $scope.contractDataService = contractDataService;

    $scope.$emit("DETAIL_PAGE_ACTIVATED", true);

    $scope.$on("NEW_SEARCH", function (event, data) {
      contractDataService.items = [];
      $state.go("search");
    });

    $scope.revertToSummary = function () {
      $state.go("search.contractAwardSummary", contractDataService.stateParams);
    };

    $scope.openProject = function (projectID, projectName) {
      // close the criteria pane

      // projectDataService.stateParams = $stateParams;
      $state.go('search.project', { projectID: projectID, projectName: projectName.urlEncode() });
    };

    // Navigate to  Contract
    $scope.openContract = function (contract) {
      var contractDescription = formatContractDescription(contract.shortContractType, contract.contractorName, contract.projectName);
      $state.go("search.contract", { contractID: contract.contractID, contractDescription: contractDescription });
    }

    var formatContractDescription = function (shortContractType, contractorName, projectName) {
      shortContractType = shortContractType || "";

      projectName = projectName || "";
      if (projectName.length > 50) projectName = projectName.substring(0, 50)

      contractorName = contractorName || "";
      if (contractorName.length > 50) contractorName = contractorName.substring(0, 50)

      return (shortContractType + "-" + contractorName + "-" + projectName).urlEncode();
    };
    //----------------------

    ////////////////////////////////////////////////////////////////////////////
    // Previous/Next Contract Navigation
    ////////////////////////////////////////////////////////////////////////////
    $scope.$watch("contractDataService.contract.contractID", function () {
      initialisePrevAndNextContractIDs();
    });

    $scope.nextContractID = 0;
    $scope.previousContractID = 0;

    $scope.gotoPreviousContract = function () {
      var currentContractIndex = getPreviousContractIndex();
      var contract = contractDataService.contractDescriptions[currentContractIndex];
      var contractDescription = contractDataService.formatContractDescription(contract.shortContractType, contract.contractorName, contract.projectName);

      $state.go('search.contract', { contractID: contract.contractID, contractDescription: contractDescription });
    };

    $scope.gotoNextContract = function () {
      var currentContractIndex = getNextContractIndex();
      var contract = contractDataService.contractDescriptions[currentContractIndex];
      var contractDescription = contractDataService.formatContractDescription(contract.shortContractType, contract.contractorName, contract.projectName);

      $state.go('search.contract', { contractID: contract.contractID, contractDescription: contractDescription });
    };


    var getCurrentContractIndex = function() {
      if (!contractDataService.contract) return;

      for (var i = 0; i < contractDataService.contractDescriptions.length; i++) {
        if (contractDataService.contractDescriptions[i].contractID == contractDataService.contract.contractID) {
          return i;
        }
      }
    };


    // skip forward to the next contract to display
    var getNextContractIndex = function() {
      var newIndex = getCurrentContractIndex();
      newIndex++;

      return newIndex;
    };


    // skip back  to the previous contract to display
    var getPreviousContractIndex = function() {
      var newIndex = getCurrentContractIndex();
      newIndex--;

      return newIndex;
    };



    var initialisePrevAndNextContractIDs = function() {
      // instantiate previous and next indices
      // if getting the next/prev index comes back undefined, set it to
      // a default value which will suppress the name display
      $scope.nextContractID = 0;
      $scope.previousContractID = 0;
      var prevIndex = getPreviousContractIndex(); // || -1;
      var nextIndex = getNextContractIndex(); // || 0;

      if (contractDataService.contractDescriptions[prevIndex] && prevIndex >= 0) $scope.previousContractID = contractDataService.contractDescriptions[prevIndex].contractID;
      if (nextIndex < contractDataService.contractDescriptions.length) $scope.nextContractID = contractDataService.contractDescriptions[nextIndex].contractID;
    };


    var previousNextContractCursorHandler = function(event) {
      $scope.$apply(function () {
        // Process required keyCodes
        if (event.keyCode == 39) $scope.gotoNextContract();
        if (event.keyCode == 37) $scope.gotoPreviousContract();
      });
    };

    /////////   /Previous/Next Contract Navigation   ///////////////////////////

    /**************************************************************************
     * Action Menu
     */
    $scope.share = function(){
      return "mailto:?subject=Information from EICDataStream&body=I thought you might be interested in this contract from EICDataStream:%0D%0A%0D%0A{{currentPath}}%0D%0A%0D%0A".replace("{{currentPath}}",$location.absUrl());
    };
    $scope.contractFeedback = function(){
      feedbackService.contractFeedback(contractDataService.contract);
      
      // If we are on a mobile, extra action is needed
      // to posiion the dialog correctly. This need to be
      // done on the next turn
      // if (window.innerWidth < 600) {
      //   setTimeout(function () {
      //     $(".modal-dialog").css({ left: 20 });
      //   }, 100);
      // };
      // .result
      //   .then(function (newMemberNote) {
      //     var i=0;

      //   }, function (e, e2) {
      //     // Action upon failure
      //     var i=1;
      //   });
    };

    $scope.print = function () {
      $window.print();
    };

    $scope.actionMenu ={
      items: [
        {
          text: "Share...",
          actionType: "href",
          action: $scope.share,
          visible: function() { return true;},
          disabled: function () { return false }
        },
        //{
        //  text: "Watch this project...",
        //  actionType:"function",
        //  action: $scope.openSelectedProjectWatchDialog,
        //  visible: function(){ return true; },
        //  disabled: false
        //},
        {
          text: "Print...",
          actionType: "function",
          action: $scope.print,
          visible: function () { return true; },
          disabled: function () { return false }
        },
        {
          text: "Ask/tell us about this contract...",
          actionType:"function",
          action: $scope.contractFeedback,
          visible: function(){ return true && $scope.MEMBER_FEEDBACK.EnableContractFeedback; },
          disabled: function () { return false }
        }
      ]
    };


    $scope.allowRevertToSummary = false;

    // set up logging parameters
    $scope.data = {
      logData: {
        contractID: $stateParams.contractID
      }
    };


    $scope.$on('$viewContentLoaded', function() {
      // Controller startup actions
      $document.bind("keydown", previousNextContractCursorHandler);
      $scope.allowRevertToSummary = contractDataService.allowRevertToSummary;

      contractDataService.getContract($stateParams.contractID);
      contractDataService.isContract = true;
    });

    $scope.$on('$destroy', function () {
      // close down the controller/ release resources etc.
      $document.unbind("keydown", previousNextContractCursorHandler);
    });

  }])
  .service("feedbackService",['dialogService',
    function(dialogService){

      this.contractFeedback = function(contract){
        dialogService.contractFeedback(contract);

        this.ensurePositionForMobile();
      };

      this.projectFeedback = function(project){
        dialogService.projectFeedback(project);

        this.ensurePositionForMobile();
      };

      this.ensurePositionForMobile = function () {
        // // If we are on a mobile, extra action is needed
        // // to posiion the dialog correctly. This need to be
        // // done on the next turn   
        if (window.innerWidth < 600) {
          setTimeout(function () {
            $(".modal-dialog").css({ left: 20 });
          }, 200);
        };
      }
  }]);

